import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Text from './Text';

const TruncateText = forwardRef(({ children, lines, ...props }, ref) => {
  return (
    <Text
      ref={ref}
      display="-webkit-box"
      lineClamp={lines}
      boxOrient="vertical"
      overflow="hidden"
      {...props}
    >
      {children}
    </Text>
  );
});

TruncateText.propTypes = {
  children: PropTypes.node,
  lines: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

TruncateText.defaultProps = {
  children: null,
  lines: 1,
};

export default TruncateText;
